import * as THREE from 'three'
import TestSceneA from './testSceneA';
import TestSceneB from './testSceneB';
import TestSceneC from './testSceneC';
import {loadTexture} from '~/js/modelViewer/loaderUtils'


class Scene extends THREE.Scene{
  constructor(){
    super();

    this.sceneA = new TestSceneA();
    this.sceneB = new TestSceneB();
    this.sceneC = new TestSceneC();

    this.currentScene = null;
    this.currentSceneName = '';
    this.rayTargetObjects = null;
  }

  async init(){
    this.cursorTexture = await loadTexture('/assets/ax_cursor.png');
    this.cursorGeom = new THREE.PlaneGeometry();
    this.cursorMaterial = new THREE.MeshBasicMaterial({map: this.cursorTexture, transparent: true});

    this.cursor = new THREE.Mesh( this.cursorGeom, this.cursorMaterial);
    this.cursor.scale.set(1.5, 1.5, 1);
    this.cursor.rotateX(-Math.PI/2);
    this.cursor.visible = false;
    this.add(this.cursor);

    await this.change('floor1')
  }

  async change(sceneName){
    // 同じシーンの場合リターン
    if(sceneName == this.currentSceneName)
      return false;
    if(this.currentScene != null){
      for(let i=0; i<this.currentScene.getSceneObjects().length; i++){
        this.remove(this.currentScene.getSceneObjects()[i]);
      }
    }

    let nextScene = null;
    if(sceneName == 'floor1'){
      await this.sceneA.loadModels();
      nextScene = this.sceneA;
    }else if(sceneName == 'floor2'){
      await this.sceneB.loadModels();
      nextScene = this.sceneB;
    }else if(sceneName == 'exterior'){
      await this.sceneC.loadModels();
      nextScene = this.sceneC;
    }else{
      console.error("no scene name");
      return false;
    }

    for(let i=0; i<nextScene.getSceneObjects().length; i++){
      this.add(nextScene.getSceneObjects()[i]);
    }
    this.rayTargetObjects = nextScene.getRayTargetObjects();
    this.currentScene = nextScene;
    return true;
  }
  
  getRayTargetObjects(){
    return this.rayTargetObjects;
  }

}

export default Scene;
